import { Component, OnInit, Inject, ViewChild } from '@angular/core';

import { SelectionModel } from '@angular/cdk/collections';
 
import { Subscription } from 'rxjs';
import { Facturedetail, Facture, Produit } from 'src/app/entity/Facture';
import { FactureService } from 'src/app/service/facture.service';
import { ComposeMailComponent } from '../../email/include/compose-mail/compose-mail.component';
import { Contact } from 'src/app/entity/Contact';
import { MailsService } from 'src/app/service/mails.service';
import { Modelcores } from 'src/app/entity/Pjoint';
import { MatTableDataSource } from '@angular/material/table';
import { Packagesponsor } from 'src/app/entity/prospect';
import { PackagesponsorService } from 'src/app/service/package.service';


@Component({
  selector: 'app-panier-form',
  templateUrl: './panier-form.component.html',
  styleUrls: ['./panier-form.component.scss']
})
export class PanierFormComponent implements OnInit {
  selectedInvoice: Facture;
  factureDetails: Facturedetail[];
  editFacturDetails: boolean;
  subscriptionInvoice: Subscription;
  dataSource: MatTableDataSource<Produit>;
  dataSourceFactureDetails: MatTableDataSource<Facturedetail>;
  displayedColumnsDetail: string[] = ['delete', 'designation', 'prixunit', 'quantite', 'remise', 'stotal'];
  displayedColumns: string[] = ['designation', 'action'];
  uploadedFiles: any[];
  ismail: boolean;
  @ViewChild(ComposeMailComponent )
  private composeMailComponent: ComposeMailComponent;

  constructor(private factureService: FactureService, private mailsService: MailsService,private packageService:PackagesponsorService) {


  }



  ngOnInit() {
    //console.log("getAllProduits0");
    this.subscriptionInvoice = this.factureService.getSelectedInvoice().subscribe(result => {
      this.selectedInvoice = result;
      //console.log("getAllProduits1");
      this.initList0();
    })


    /*
        this.subscriptionInvoice=this.factureService.getSelectedInvoice().subscribe(result=>{
          this.selectedInvoice=result;
        }  )
    
    */


  }
  importerDepuisSponsor(factureDetail:Facturedetail){
 
  
      this.packageService.getByProspect(this.selectedInvoice.client.prospectId.prospectId).subscribe(p => {
 
        if(p)
        factureDetail.designation=this.strip(p.detail)
 
      }
      );
 


  }
    strip(html)
  {
     var tmp = document.createElement("DIV");
     tmp.innerHTML = html;
     return tmp.textContent||tmp.innerText;
  }
  select(produit: Produit) {

    this.factureService.selectedOneProd(this.selectedInvoice.idfacture, produit).subscribe(result => {
      this.editFacturDetails = true;
      this.initList0();

    });
  }


  initList0() {

    this.factureService.getAllDetailFacture(this.selectedInvoice.idfacture).subscribe(result => {
      this.factureDetails = result;
      this.dataSourceFactureDetails = new MatTableDataSource(result);
      //console.log("getAllDetailFacture1");

      this.initList(this.selectedInvoice, this.factureDetails);
    });
  }
  removeDetail(factureDetail: Facturedetail) {
    if (window.confirm("Are you sure")) {
      this.factureService.removeDetail(factureDetail).subscribe(result => {

        this.initList0();
      })
    }
  }
  saveList( ) {
    if (this.editFacturDetails) {
      //console.log("save list this.selectedInvoice",this.selectedInvoice);
      this.factureService.saveAllDetailFacture(this.selectedInvoice.idfacture, this.dataSourceFactureDetails.data).subscribe(result => {
        this.editFacturDetails = false;
        this.factureService.nextEditInvoice(this.selectedInvoice)
        
          this.getFacture(); 
    
  
     
      });
    }

  }
  getFacture() {
    this.factureService.get(this.selectedInvoice.idfacture).subscribe(result => {
      this.selectedInvoice = result;
   //console.log("this.selectedInvoice",this.selectedInvoice);
   console.log("getFacture");
      this.initList0();

    })
  }

  cancelList() {
    if (window.confirm("Are you sure")) {
      this.editFacturDetails = false;
      this.initList0();
    }
  }
  
  initList(invoice: Facture, factureDetails: Facturedetail[]) {
    let produits: number[] = [];
    let produitsShow: Produit[] = [];

    if (factureDetails)
      factureDetails.forEach(element => {
        produits.push(element.produit.produitId);


      });

    this.selectedInvoice = invoice;
//console.log("getAllProduits");

    this.factureService.getAllProduits().subscribe(result => {
      result.forEach(element => {
        if (!produits.includes(element.produitId))
          produitsShow.push(element)

      });
      this.dataSource = new MatTableDataSource(produitsShow);


    });
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  sendFacture() {
    this.sendProforma(this.selectedInvoice, false)
  }



  sendProforma(facture: Facture, isAnglais: boolean) {


    this.uploadedFiles = []

    this.factureService.printPersonaliser(facture, isAnglais, true, "", "", "",false).subscribe(
      (res) => {
        var filename = facture.prospectprospectId.raisonSocial + '_proforma.pdf';

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
        res.name = filename;
        this.uploadedFiles.push(res);
        this.mailsService.findodel(6).subscribe(result => {

          this.composeMailComponent.prepareEmailModel(result, this.selectedInvoice.contactcontactId, "NAPEC", facture.prospectprospectId, this.uploadedFiles)
        })

      }
    );

  }




}
